import isBot from 'isbot';
import Vue from 'vue';

export default function splashAccepted(to, from, next) {
    const splashNeeded = (to.meta.splash !== false && !isBot(navigator.userAgent));
    const splashAccepted = localStorage.getItem('splashAccepted') || false;

    if(splashAccepted) {
        if(to.meta.splash === false){
            return Vue.router.push({ name: 'home' });
        }
    }else{
        if (splashNeeded) {
            window.splashRedirectIntended = to.fullPath;
            return Vue.router.push({name: 'splash'});
        }
    }

    return next();
}